import slugify from 'slugify';

export const slugifier = (value) => {
    return slugify(value, {
        replacement: '',
        remove: /[-,*+~.()'"!:@]/g,
    });
};
